import "./contact.css";
import { useState } from "react";
import axios from "axios";
import {HashLoader } from "react-spinners";
import Failuremessage from "./failuremessage";
import { useMediaQuery } from "react-responsive";

export default function Contact(){
    const rootUrl = "http://localhost:3000";
  const localrootUrl = "https://ahkserver.onrender.com";

  const [res,setRes]=useState();
  const [loading,setLoading] = useState(false);
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

    const [formdata,setformdata] = useState({
        fname:"",
        lname:"",
        email:"",
        message:""
    })
    function checkifempty(data){
        if(data==""||null){
            return true;
        }else{
            return false;
        }
    }
    async function handleSubmit(event){
        event.preventDefault();
        setLoading(true);
        if(checkifempty(formdata.fname)||checkifempty(formdata.lname)||checkifempty(formdata.email)||checkifempty(formdata.message)){
            return false
        }
        const postContact = await axios.post(`${localrootUrl}/contactinfo`,formdata);
        setLoading(false);
        const response = postContact.data;    
        if(response.success){
            setRes(true);
        }else{
            setRes(false);
        }
    }

    return <div className="contact-page">
        <p className="qone">Got a Question for us?</p>
        <p className="qtwo">AHK Portable X-Ray and Diagnostic</p>
        {loading?<HashLoader size={50} className="newloader" loading={loading}/>:res?res.failure?<Failuremessage isFail={true}/>:<Failuremessage isFail={false}/>:<p className="qone">We Are Here To Listen.</p>}
            <form className="contact-form" onSubmit={handleSubmit}>  
                <div className={isMobile?"form-col":"form-row"}>
                    <div className="form-col" style={{width:"auto"}}>
                        <label className="label-contact" style={checkifempty(formdata.fname)?{color:"red"}:null}>FIRST NAME{checkifempty(formdata.fname)?"*":null}</label>
                        <input className="input-contact" onChange={(event)=>setformdata({...formdata,fname:event.target.value})} type="text" name="fname" />
                    </div>
                    <div className="form-col" style={{width:"auto"}}>
                        <label className="label-contact" style={checkifempty(formdata.lname)?{color:"red"}:null}>LAST NAME{checkifempty(formdata.lname)?"*":null}</label>
                        <input className="input-contact" onChange={(event)=>setformdata({...formdata,lname:event.target.value})} type="text" name="lname" />
                    </div>
                </div>
                <div className="form-col" style={{width:"auto"}}>
                    <label className="label-contact" style={checkifempty(formdata.email)?{color:"red"}:null}>ENTER EMAIL{checkifempty(formdata.email)?"*":null}</label>
                    <input className="input-contact" onChange={(event)=>setformdata({...formdata,email:event.target.value})} type="email" name="email"/>
                </div>
                <div className="form-col" style={{width:"auto"}}>
                    <label style={checkifempty(formdata.message)?{color:"red"}:null} className="label-contact">MESSAGE{checkifempty(formdata.message)?"*":null}</label>
                    <textarea style={{height:"6vw"}} name="message" onChange={(event)=>setformdata({...formdata,message:event.target.value})}/>
                </div>
                <button className="contact-submit">SEND MESSAGE</button>
            </form>
    </div>
}
